import React from "react";
import styled from "styled-components";

const TitleStyled = styled.h2(
  ({ color, theme }) => `
    font-size: 36px;
    font-weight: 800;
    color: ${theme.colors[color] || theme.colors.black};
    text-align: center;
`
);

export const Title = ({ color, children }) => (
  <TitleStyled color={color}>{children}</TitleStyled>
);
